import React from 'react';
import { twMerge } from 'tailwind-merge';

export interface CardHighlightBoxProps {
  children: React.ReactNode;
  className?: string;
}

export const CardHighlightBox: React.FC<CardHighlightBoxProps> = ({ children, className }) => (
  <div
    className={twMerge(
      'flex rounded-ds-3 min-h-ds-16 p-3 items-start gap-2.5 bg-ds-bg-surface-soft-4',
      className,
    )}
  >
    {children}
  </div>
);
